// 조용한 온천 보행 격자: 눈밭 바깥, 탕(테두리 0.75 여유), 사각형·원 장애물을 막는다. 프로토타입 850–866.
import { createNavGrid, type NavGrid } from '../../engine/nav';
import { inPool, inRect, type QuietLayout } from './layout';

export function buildQuietGrid(L: QuietLayout): NavGrid {
  const nav = createNavGrid({ x0: -44, z0: -50, cs: 0.5, nx: 176, nz: 176 });
  nav.blockWhere((x, z) =>
    Math.hypot(x, z + 6) > 38 ||
    L.pools.some((P) => inPool(P, x, z, 0.75)) ||
    L.obstacles.some((o) => o.rect && inRect(o, x, z, 0.35)));
  L.obstacles.forEach((o) => { if (!o.rect) nav.markCircle(o.x, o.z, o.r + 0.35); });
  return nav;
}
